import React, { useState, useEffect, useMemo, useRef } from "react";
import UpDownArrow from "../assets/ic_updown.svg";
import placeholder from "../assets/placeholder.svg"
import config from '../config'

const UserList = () => {
  const [userList, setUserList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [activeActionId, setActiveActionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    user: null,
    action: null, // "block" | "unblock"
  });
  // Ref for action menu container to detect outside clicks
  const actionMenuRef = useRef(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target)
      ) {
        setActiveActionId(null);
      }
    }

    if (activeActionId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeActionId]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
const res = await fetch(`${config.BASE_URL}/get/alluser`);
      const data = await res.json();
      if (data.success) {
        setUserList(data.data);
      } else {
        alert("Failed to load users");
      }
    } catch (error) {
      console.error(error);
      alert("Error fetching users");
    } finally {
      setLoading(false);
    }
  };


  // Jab action menu me Block/Unblock click ho
  const requestBlockToggle = (user) => {
    setConfirmDialog({
      open: true,
      user,
      action: user.blockStatus === 1 ? "unblock" : "block",
    });
  };

  // Confirm dialog me OK click
  const confirmBlockToggle = async () => {
    const { user } = confirmDialog;
    if (!user) return;

    try {
    const res = await fetch(`${config.BASE_URL}/block-toggle/${user.id}`, {
  method: "PATCH",
});

      const data = await res.json();

      if (data.success) {
        setUserList((prev) =>
          prev.map((u) =>
            u.id === user.id ? { ...u, blockStatus: data.data.blockStatus } : u
          )
        );

        alert(
          data.data.blockStatus === 1
            ? "User blocked successfully."
            : "User unblocked successfully."
        );
      } else {
        alert("Failed to update block status");
      }
    } catch (err) {
      console.error(err);
      alert("Error updating block status");
    } finally {
      setConfirmDialog({ open: false, user: null, action: null });
      setActiveActionId(null);
    }
  };

  // const toggleBlockStatus = async (id) => {
  //   try {
  //     const res = await fetch(`http://localhost:3000/apis/block-toggle/${id}`, {
  //       method: "PATCH",
  //     });
  //     const data = await res.json();
  //     if (data.success) {
  //       setUserList((prev) =>
  //         prev.map((user) =>
  //           user.id === id ? { ...user, blockStatus: data.data.blockStatus } : user
  //         )
  //       );
  //       setActiveActionId(null);

  //       if (data.data.blockStatus === 1) {
  //         alert("User blocked successfully.");
  //       } else {
  //         alert("User unblocked successfully.");
  //       }
  //     } else {
  //       alert("Failed to update block status");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert("Error updating block status");
  //   }
  // };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    } else if (sortConfig.key === key && sortConfig.direction === "desc") {
      direction = null;
      key = null;
    }
    setSortConfig({ key, direction });
  };

  const filteredUsers = useMemo(() => {
    if (!searchTerm) return userList;
    const lowerSearch = searchTerm.toLowerCase();
    return userList.filter(
      (user) =>
        user.name.toLowerCase().includes(lowerSearch) ||
        user.email.toLowerCase().includes(lowerSearch) ||
        (user.phoneNumber || "").toLowerCase().includes(lowerSearch) ||
        (user.gender || "").toLowerCase().includes(lowerSearch)
    );
  }, [searchTerm, userList]);

  const sortedUsers = useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) return filteredUsers;
    const sorted = [...filteredUsers].sort((a, b) => {
      let aVal = a[sortConfig.key]?.toString().toLowerCase() || "";
      let bVal = b[sortConfig.key]?.toString().toLowerCase() || "";
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredUsers, sortConfig]);

  const totalEntries = sortedUsers.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const paginatedUsers = useMemo(() => {
    const start = (currentPage - 1) * entriesPerPage;
    return sortedUsers.slice(start, start + entriesPerPage);
  }, [sortedUsers, currentPage, entriesPerPage]);

  const goToPage = (page) => {
    if (page < 1) page = 1;
    else if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };

  const toggleAction = (id) => {
    setActiveActionId((prev) => (prev === id ? null : id));
  };

  const headers = [
    { label: "Full Name", key: "name" },
      { label: "Username", key: "username" },
    { label: "Email", key: "email" },
  
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen font-sans relative">
      {/* Loading Overlay */}
      {loading && (
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 shadow-lg flex items-center space-x-3">
            <svg
              className="animate-spin h-6 w-6 text-blue-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
            <span className="text-blue-600 font-semibold text-lg">Loading...</span>
          </div>
        </div>
      )}

      {/* Controls */}
      <div className="mb-4 flex flex-wrap justify-between items-center gap-3 bg-white rounded-[6px] px-4 py-3">
        <div className="flex items-center space-x-2">
          <label htmlFor="entries" className="text-gray-700 font-medium">
            Show
          </label>
          <div className="relative w-20">
            <input
              type="number"
              id="entries"
              value={entriesPerPage}
              onChange={(e) => {
                const val = Math.max(1, Number(e.target.value));
                setEntriesPerPage(val);
                setCurrentPage(1);
              }}
              className="w-full text-center border border-gray-300 rounded-md px-2 py-2 pr-6 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            />
            <div className="absolute inset-y-0 right-2 flex flex-col justify-center">
              <button
                type="button"
                onClick={() => {
                  setEntriesPerPage((prev) => prev + 1);
                  setCurrentPage(1);
                }}
                className="text-gray-600 hover:text-black leading-none"
              >
                ▲
              </button>
              <button
                type="button"
                onClick={() => {
                  if (entriesPerPage > 1) {
                    setEntriesPerPage((prev) => prev - 1);
                    setCurrentPage(1);
                  }
                }}
                className="text-gray-600 hover:text-black leading-none"
              >
                ▼
              </button>
            </div>
          </div>
          <span className="text-gray-700">entries</span>
        </div>

        <input
          type="search"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto p-3 bg-white rounded-[6px] border border-transparent">
        <table className="w-full text-left text-sm text-gray-700 table-fixed border border-gray-200">
          <thead className="bg-white border-b border-gray-300">
            <tr className="divide-x divide-gray-300">
              {headers.map(({ label, key }) => (
                <th key={key} className="p-4 select-none">
                  <div className="inline-flex items-center whitespace-nowrap space-x-2">
                    <span>{label}</span>
                    <img
                      src={UpDownArrow}
                      alt="Sort"
                      className={`w-4 h-4 cursor-pointer transition-transform ${sortConfig.key === key
                        ? sortConfig.direction === "asc"
                          ? "rotate-180"
                          : "rotate-0"
                        : ""
                        }`}
                      onClick={() => handleSort(key)}
                    />
                  </div>
                </th>
              ))}
              <th className="p-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {paginatedUsers.length === 0 ? (
              <tr>
                <td colSpan={6} className="p-4 text-center text-gray-500">
                  No users found.
                </td>
              </tr>
            ) : (
              paginatedUsers.map((user, index) => (
                <tr
                  key={user.id}
                  className={`divide-x divide-gray-300 ${index % 2 === 0 ? "bg-gray-100" : "bg-white"
                    }`}
                >
                  <td className="p-4 whitespace-nowrap">
                    <div className="flex items-center gap-3">
                      <img
                        src={user.dp ? `${config.BASE_URL}uploads/${user.dp}` : placeholder}
                        alt={user.name}
                        className="w-10 h-10 rounded-full object-cover shrink-0"
                      />
                      <p
                        className="font-semibold text-gray-900 max-w-[160px] leading-snug overflow-hidden text-ellipsis whitespace-normal"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {user.name}
                      </p>
                    </div>
                  </td>
                  <td className="p-4 whitespace-nowrap text-gray-700">{user.userName || "-"}</td>

                  <td className="p-4 max-w-xs break-words whitespace-normal text-gray-600">
                    {user.email}
                  </td>
                  <td className="p-4 text-center relative">
                    <button
                      onClick={() => toggleAction(user.id)}
                      className="p-1 hover:bg-gray-200 rounded-full"
                      aria-label="Open action menu"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-gray-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <circle cx="10" cy="3" r="2" />
                        <circle cx="10" cy="10" r="2" />
                        <circle cx="10" cy="17" r="2" />
                      </svg>
                    </button>

                    {activeActionId === user.id && (
                      <div
                        ref={actionMenuRef}
                        className="absolute top-8 right-1 bg-white border border-gray-300 rounded-md shadow-lg px-3 py-2 text-sm text-gray-800 whitespace-nowrap z-10"
                      >
                        <button
                          onClick={() => requestBlockToggle(user)}
                          className={`hover:text-red-600 ${user.blockStatus === 1 ? "text-green-600" : ""}`}
                        >
                          {user.blockStatus === 1 ? "Unblock User" : "Block User"}
                        </button>

                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="mt-4 flex flex-col md:flex-row items-center justify-between text-gray-600 text-sm space-y-2 md:space-y-0">
          <div className="text-black font-bold">
            Showing{" "}
            {totalEntries === 0 ? 0 : (currentPage - 1) * entriesPerPage + 1} to{" "}
            {Math.min(currentPage * entriesPerPage, totalEntries)} of {totalEntries} entries
          </div>

          <div className="flex items-center space-x-1">
            <button
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
              className="p-1 rounded-full hover:bg-gray-200 disabled:opacity-50"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) =>
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 2 && page <= currentPage + 2)
              )
              .map((page, i, arr) => {
                if (i > 0 && page - arr[i - 1] > 1) {
                  return (
                    <React.Fragment key={`gap-${page}`}>
                      <span className="px-3 py-1 text-gray-500 select-none">...</span>
                      <button
                        onClick={() => goToPage(page)}
                        className={`px-3 py-1 rounded ${page === currentPage
                          ? "bg-[#000000] text-white font-semibold"
                          : "hover:bg-gray-200"
                          }`}
                      >
                        {page}
                      </button>
                    </React.Fragment>
                  );
                }
                return (
                  <button
                    key={page}
                    onClick={() => goToPage(page)}
                    className={`px-3 py-1 rounded ${page === currentPage
                      ? "bg-[#000000] text-white font-semibold"
                      : "hover:bg-gray-200"
                      }`}
                  >
                    {page}
                  </button>
                );
              })}

            <button
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
              className="p-1 rounded-full hover:bg-gray-200 disabled:opacity-50"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {confirmDialog.open && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
    <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
      <div className="px-6 py-4 ">
        <h2 className="text-lg font-bold text-gray-800">
          {confirmDialog.action === "block" ? "Block User" : "Unblock User"}
        </h2>
      </div>
      <div className="px-6 py-4">
        <p className="text-gray-600">
          {confirmDialog.action === "block"
            ? `Are you sure you want to block ?`
            : `Are you sure you want to unblock?`}
        </p>
      </div>
      <div className="px-6 py-4 flex justify-end space-x-3 ">
        <button
          onClick={() =>
            setConfirmDialog({ open: false, user: null, action: null })
          }
          className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          onClick={confirmBlockToggle}
          className="px-4 py-2 bg-[#000000] text-white rounded-md hover:bg-[#000000]-600"
        >
          OK
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default UserList;
